export enum LandingPageIDViewModel 
{
    CONFIGPAGE = 0,
    DRIVERSPAGE = 1,
    BSODPAGE = 2,
    MONITORINGPAGE = 3,
    REALTIMEMONITORINGPAGE = 4
}
